import { useAuth0 } from "@auth0/auth0-react";
import ArrowDSVG from "assets/icons/svg/arrow-details";
import AutoCompleteField from "components/autoCompleteField";
import MyButton from "components/MyButton";
import MyModal from "components/MyModal";
import SearchComp from "components/Searchcomponent";
import Tabs from "components/Tabs";
import { SubHeader } from "layout/SubHeader";
import FinanceService from "Lib/API/Finance";
import { addLedgerAccounts } from "pages/School/Classes/classSlice";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory, useParams } from "react-router-dom";
import "../index.scss";
import ActivatedSubCategories from "./activeSubCategories";
import { AddSubcategory } from "./addSubcatgory";
import DeactivatedSubCategories from "./deactiveatedSubCategories";

const SubCategory = () => {
  const { ledgerAccounts } = useSelector((state) => state?.data);
  const [activeTab, setActiveTab] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = useState({});
  const [editClicked, setEditClicked] = useState(false);
  const [refresh, setRefresh] = React.useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const history = useHistory();
  const params = useParams();
  const title = history?.location?.state;

  const enableLoading = (value) => {
    setLoading(value);
  };

  const dispatch = useDispatch();
  const ledger_id = params?.ledger_id;
  const [searchText, setSearchText] = React.useState("");
  const [value, setValue] = useState({
    value: ledger_id,
    label: title,
  });

  React.useEffect(() => {
    history.push(`/sub-category/${value?.value}`, value?.label);
  }, [value, history]);

  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      if (ledgerAccounts.length === 0)
        await FinanceService.getLedgeraccounts("filter?active=true", token)
          .then((res) => {
            if (res.length) {
              const ledger_accounts = [];
              res.map((item) => {
                ledger_accounts.push({
                  value: item?._id,
                  label: item?.led_acc_name,
                });
                item.id = item._id;
                return item;
              });
              dispatch(addLedgerAccounts(ledger_accounts));
            }
            enableLoading(false);
          })
          .catch((err) => {
            enableLoading(false);
            toastr.error("Error", err?.data?.message);
          });
    }
    fetchMyAPI();
    enableLoading(true);
  }, [getAccessTokenSilently, dispatch, ledgerAccounts]);
  return (
    <div className="school-classes pr-12 pt-5">
      <div className="header ">
        <div className="header-tittle">
          {params?.ledger_id !== "1" && (
            <ArrowDSVG
              style={{ cursor: "pointer" }}
              onClick={() => history.push("/finance")}
            />
          )}
          <SubHeader
            className="subheader"
            {...{
              title: `Subcategory List ${title ? "-" + title : ""}`,
            }}
          />
        </div>
        <div className="new-class">
          <MyButton
            style={{ width: "190px", height: "auto" }}
            type={"primary"}
            content={"Add Subcategory"}
            onClick={() => {
              setEditClicked(false);
              setData({});
              setOpenModal(!openModal);
            }}
          />
        </div>
      </div>
      <div>
        <Tabs
          tabs={[
            {
              title: "Activated Subcategories",
              content: (
                <>
                  <div className="activated-ledger">
                    <div className="sub-header-functions ">
                      <div className="mr-5">
                        <AutoCompleteField
                          style={{
                            width: "200px",
                            height: "45px",
                            border: "none",
                          }}
                          loading={loading}
                          classNamePrefix="react-select"
                          options={[
                            { value: "1", label: "All" },
                            ...ledgerAccounts,
                          ]}
                          placeholder="Ledger Account"
                          onChange={(value) => {
                            setValue(value);
                          }}
                          defaultValue={
                            title
                              ? {
                                  value: ledger_id,
                                  label: title,
                                }
                              : ""
                          }
                        />
                      </div>
                      <SearchComp
                        value={searchText}
                        setSearchText={setSearchText}
                      />
                    </div>
                  </div>
                  <ActivatedSubCategories
                    searchText={searchText}
                    ledgerName={title}
                    ledger_id={ledger_id}
                    setData={setData}
                    setEdit={setOpenModal}
                    setEditClicked={setEditClicked}
                    refresh={refresh}
                    setRefresh={setRefresh}
                  />
                </>
              ),
            },
            {
              title: "Deactivated Subcategories",
              content: (
                <>
                  <div className="activated-ledger">
                    <div className="sub-header-functions ">
                      <div className="mr-5">
                        <AutoCompleteField
                          style={{
                            width: "200px",
                            height: "45px",
                            border: "none",
                          }}
                          classNamePrefix="react-select"
                          options={[
                            { value: "1", label: "All" },
                            ...ledgerAccounts,
                          ]}
                          placeholder="Ledger Account"
                          onChange={(value) => {
                            setValue(value);
                          }}
                          defaultValue={
                            title
                              ? {
                                  value: ledger_id,
                                  label: title,
                                }
                              : ""
                          }
                        />
                      </div>
                      <SearchComp
                        value={searchText}
                        setSearchText={setSearchText}
                      />
                    </div>
                  </div>
                  <DeactivatedSubCategories
                    searchText={searchText}
                    refresh={refresh}
                    setRefresh={setRefresh}
                  />
                </>
              ),
            },
          ]}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          type="secondary"
        ></Tabs>
      </div>
      <MyModal
        className="add-ledger-modal"
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      >
        <AddSubcategory
          title={title}
          id={ledger_id}
          setOpenModal={setOpenModal}
          open={openModal}
          refresh={refresh}
          setRefresh={setRefresh}
          data={data}
          editClicked={editClicked}
          defaultValue={
            title
              ? {
                  value: ledger_id,
                  label: title,
                }
              : ""
          }
        />
      </MyModal>
    </div>
  );
};

export default SubCategory;
